<template>
  <div class="algorithm">
    <el-table class="problem-table" row-class-name="problem-table-row" header-row-class-name="problem-table-row"
      :header-cell-style="{ backgroundColor: 'transparent' }" :data="tableData" height="100%">
      <el-table-column prop="typeName" label="类型" width="150" align="center"> </el-table-column>
      <el-table-column prop="name" label="算法名称" width="220" align="center"> </el-table-column>
      <el-table-column prop="number" label="已完成题目" width="120" align="center"> </el-table-column>
      <el-table-column prop="problem" label="题号">
        <template slot-scope="scope">
          <div class="question-con" :ref="'conItems_' + scope.$index">
            <div class="question-box" :ref="'boxItems_' + scope.$index"
              :style="{ maxHeight: scope.row.isExpanded ? 'none' : maxHeight + 'px' }">
              <div :class="['question-item']" :style="{ backgroundColor: difficulty[item.diff] }"
                v-for="item in scope.row.problemArr" :key="item.id" @click="toProblemInfo(item.id)">
                {{ item.id + "-" + item.name }}
              </div>
            </div>
            <div class="question-icon" v-if="scope.row.showExpand" @click="toggleExpand(scope.row)">
              <i :class="[scope.row.isExpanded ? 'el-icon-caret-top' : 'el-icon-caret-bottom']"></i>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getOjStatistics } from '@/api/xinAoTraining';
export default {
  name: "algorithm",
  components: {},
  data() {
    return {
      tableData: [],
      difficulty: {
        "入门": "rgb(252, 79, 100)",
        "普及-": "rgb(241, 155, 44)",
        "普及/提高-": "rgb(239, 196, 22)",
        "普及+/提高": "rgb(87, 194, 45)",
        "提高+/省选-": "rgb(59, 153, 217)",
        "省选/NOI-": "rgb(156, 68, 204)",
        "NOI/CTSC": "rgb(15, 32, 103)",
        "": "rgb(191, 191, 191)"
      },
      maxHeight: 0,
      resizeObserver: null
    }
  },
  created() { },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.getOjStatistics();
      }, 200);
    })
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    getOjStatistics() {
      getOjStatistics().then(res => {
        if (res.status) {
          const list = res.data.list;
          const tableData = list.flatMap(typeItem => {
            return typeItem.child.map((algorithm, index) => ({
              typeId: typeItem.id,
              typeName: index === 0 ? typeItem.name : '', // 只有第一个算法保留类型名称
              id: algorithm.id,
              name: algorithm.name,
              number: algorithm.child.length,
              problemArr: [...algorithm.child], // 使用展开运算符创建新数组
              isExpanded: false, // 是否展开
              showExpand: false, // 是否显示展开按钮
            }));
          });
          // console.log("tableData: ", JSON.parse(JSON.stringify(tableData)));
          this.tableData = tableData;
          this.$nextTick(() => {
            this.initObserver();
            this.calculateItems();
          })
        }
      })
    },
    toProblemInfo(problemId) {
      this.$router.push({
        name: 'singleProblemInfo', query: {
          problemId: problemId,
          activeTab: 3
        }
      })
    },
    initObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        this.calculateItems();
      });
      this.$nextTick(() => {
        this.tableData.forEach((_, index) => {
          const ref = this.$refs[`conItems_${index}`];
          if (ref) {
            this.resizeObserver.observe(ref);
          }
        })
      });
    },
    calculateItems() {
      this.$nextTick(() => {
        // 计算单个item的高度
        const firstBox = this.$refs['boxItems_0'];
        if (!firstBox || !firstBox.firstElementChild) return;

        const itemHeight = firstBox.firstElementChild.offsetHeight;
        const htmlFontSize = document.documentElement.style.fontSize; // 根元素font-size
        const itemMargin = parseFloat(htmlFontSize) * 0.4; // item的外间距0.4rem转px
        const lineHeight = Math.floor(itemHeight + itemMargin);
        this.maxHeight = lineHeight * 2; // 2行的高度

        // 计算每个容器是否需要显示展开按钮
        this.tableData.forEach((item, index) => {
          const boxEl = this.$refs[`boxItems_${index}`];

          const contentHeight = boxEl.scrollHeight;
          item.showExpand = contentHeight > this.maxHeight;

          // 如果不需要展开，确保isExpanded为false
          if (!item.showExpand) {
            item.isExpanded = false;
          }
        })
      });
    },
    toggleExpand(item) {
      item.isExpanded = !item.isExpanded;
      // 强制重新计算布局，确保动画生效
      this.$nextTick(() => {
        this.calculateItems();
      });
    }
  }
}
</script>

<style scoped lang="scss">
.algorithm {
  color: #FFF;
  height: 100%;

  .problem-table {

    .question-con {
      display: flex;

      .question-box {
        flex: 1;
        display: flex;
        flex-wrap: wrap;

        .question-item {
          font-size: 0.64rem;
          line-height: 1rem;
          margin: 0.2rem;
          padding: 0 0.4rem;
          border-radius: 0.1rem;
          cursor: pointer;

          &:hover{
            color: #409EFF;
          }
        }
      }

      .question-icon {
        cursor: pointer;
        padding: 0.5rem;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>

<style scoped lang="scss">
::v-deep.problem-table {
  margin: 0 auto;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(26, 26, 26, .1);
  background-color: transparent;

  .el-table__body-wrapper {
    overflow-y: auto !important;
  }

  .el-table__empty-block,
  .problem-table-row {
    background-color: rgba(255, 255, 255, .1);
  }

  .el-table__body {
    td.el-table__cell {
      padding: 0.2rem 0;
    }

    tr.current-row > td.el-table__cell,
    tr:hover > td.el-table__cell {
      background-color: #69bbc480;
    }
  }
}
</style>
